<script lang="ts">
export default {
  name: 'DialogFooter',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
}

const props = defineProps<Props>();

const footerClass = computed(() => cn('tw:flex tw:sm:flex-row tw:sm:justify-end tw:sm:space-x-2', props.class));
</script>
<template>
  <div :class="footerClass">
    <slot />
  </div>
</template>
